import type { ReactElement } from 'react';
import { Outlet, ScrollRestoration } from 'react-router';

import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/**
 * 모든 사용자 화면의 껍데기.
 *
 * 위젯끼리는 서로 참조할 수 없으므로(FSD) GNB·푸터 조합은 app 레이어가 맡는다.
 * 본문 폭은 페이지가 정한다 — 홈처럼 전폭 밴드를 쓰는 화면이 있기 때문이다.
 *
 * ScrollRestoration — 새 화면은 맨 위에서 열고, 뒤로 가기는 떠난 자리로 되돌린다.
 * 없으면 SPA 이동이 이전 화면의 스크롤 위치를 그대로 물려받는다(긴 교육 랜딩에서
 * 「상담 신청하기」를 누르면 문의 폼이 아래쪽에서 열리던 원인). `#앵커` 이동은 그 자리로 간다.
 */
export function RootLayout(): ReactElement {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <ScrollRestoration />
      <SiteHeader />
      <div className="flex-1">
        <Outlet />
      </div>
      <SiteFooter />
    </div>
  );
}
